import Styles from './LiveHelpButton.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { useButton } from '@react-aria/button'
import { LiveHelpButtonProps, LiveHelpTriggerProps } from 'components/LiveHelpButton/Types'
import { forwardRef } from 'react'
import { useObjectRef } from '@react-aria/utils'
import { LiveHelpTrigger } from 'components/LiveHelpButton/LiveHelpTrigger'

export const Button = forwardRef<HTMLButtonElement, LiveHelpButtonProps>((props, fRef) => {
  const ref = useObjectRef(fRef)
  const { buttonProps } = useButton(props, ref)
  return (
    <button className={Styles.supportButton} ref={ref} {...buttonProps}>
      <div className={Styles.avatar}>
        <img
          className={Styles.face}
          src="https://res.cloudinary.com/almanac/image/upload/v1756854485/blaze_assets/virtual_marketer/strategies/face_jsgnb8.png"
          alt="Support Avatar"
        />
      </div>
      <Text variant="smallList">Get Live Help</Text>
    </button>
  )
})

export const LiveHelpButton = (props: LiveHelpTriggerProps) => (
  <LiveHelpTrigger {...props}>
    <Button />
  </LiveHelpTrigger>
)
